
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college",
      function () {
        return require("private-next-pages/college/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college"])
      });
    }
  